import { createServerFn } from "@tanstack/react-start"
import { getRequest } from "@tanstack/react-start/server"
import { z } from "zod"
import { PROJECT_STATUSES } from "@/features/project-status/core/projectStatus"
import {
  assertPermission,
  getAuthenticatedUser,
  getUserStoreRestrictions,
} from "@/lib/assert-permission.server"
import { authFunctionMiddleware } from "@/lib/auth-middleware"
import { queryMaterialsOverview } from "./materialsOverviewQuery"

const filtersSchema = z.object({
  status: z.enum(PROJECT_STATUSES),
  countryIds: z.array(z.string()).optional(),
})

export type MaterialsOverviewParams = z.infer<typeof filtersSchema>

export const getMaterialsOverviewReport = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .inputValidator((data: unknown) => filtersSchema.parse(data))
  .handler(async ({ data }) => {
    const request = getRequest()
    await assertPermission(request, "project", "read")
    const user = await getAuthenticatedUser(request)
    const restrictions = getUserStoreRestrictions(user)

    return queryMaterialsOverview({
      filters: { status: data.status, countryIds: data.countryIds },
      restrictions,
    })
  })
